import { ApiResponse } from '../types/api';
import { HistoricalUtrsQueryByCodeParams, HistoricalUtrsResponse } from '../types/insight-custom-dashboard';
import { g17ecoApi } from './g17ecoApi';

const transformResponse = <T>(response: ApiResponse<T>) => response.data;

export const insightsApi = g17ecoApi
  .enhanceEndpoints({
    addTagTypes: ['insights'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getHistoricalUtrsByCodes: builder.query<HistoricalUtrsResponse, HistoricalUtrsQueryByCodeParams>({
        transformResponse,
        query: ({ initiativeId, utrCodes, queryParams }) => {
          return {
            url: `universal-trackers/utrs-history/initiativeId/${initiativeId}`,
            method: 'post',
            data: { utrCodes, filters: queryParams },
            params: { period: queryParams.period, surveyType: queryParams.surveyType },
          };
        },
        providesTags: ['insights'],
      }),
    }),
  });

export const { useLazyGetHistoricalUtrsByCodesQuery } = insightsApi;
